var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointRight = function SvgPointRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m3.537 21 8.598.86a3.5 3.5 0 0 0 3.76-2.7l.916-3.993h4.177a2.333 2.333 0 0 0 0-4.667h-8.117l.554-.554a2.062 2.062 0 1 0-2.917-2.917L9.223 8.315a5.2 5.2 0 0 1-2.415 1.368l-3.27.817z"
  })));
};
export default SvgPointRight;